const MS_IN_SEC = 1000;
export const MS_IN_MIN = 60 * MS_IN_SEC;
const MS_IN_HOUR = 60 * MS_IN_MIN;
const MS_IN_DAY = 24 * MS_IN_HOUR;

interface TimeSpan {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export default function msInUnits(ms: number): TimeSpan {
    if (ms >= 0) {
        const days = Math.floor(ms / MS_IN_DAY);
        let leftMS = ms - days * MS_IN_DAY;

        const hours = Math.floor(leftMS / MS_IN_HOUR);
        leftMS -= hours * MS_IN_HOUR;

        const minutes = Math.floor(leftMS / MS_IN_MIN);
        leftMS -= minutes * MS_IN_MIN;

        const seconds = Math.floor(leftMS / MS_IN_SEC);

        return { days, hours, minutes, seconds };
    }

    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
}
